/**
 * Inspections Line-2 peers.
 * Overview is the current list. New inspection is the create form.
 */

export function getInspectionPeerNav(pathname, { canCreate = true } = {}) {
  const peers = [{ id: 'overview', label: 'Overview', to: '/jobs' }];
  if (canCreate) {
    peers.push({ id: 'new', label: 'New inspection', to: '/jobs/new' });
  }
  const activeId = String(pathname || '').startsWith('/jobs/new') ? 'new' : 'overview';
  return peers.map((p) => ({ label: p.label, to: p.to, active: p.id === activeId }));
}
